import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Header from '../components/AdminHeader';
import { deleteDocumentById, getDocuments } from '../../services';
import { toast } from 'react-toastify';
import Swal from 'sweetalert';
import Spinner from '../../components/Spinner';

const AdminDocuments = () => {
    const [documents, setDocuments] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch()

    const doLogout = async () => {
        dispatch({ type: 'USER', payload: {} });
        localStorage.removeItem('token');
        window.location.href = '/admin';
    };

    const getDocumentList = async () => {
        setSpinner(true)
        try {

            const response = await getDocuments();
            if (response) {
                if (response?.status === 200) {
                    // console.log("res", response)
                    setDocuments(response?.data)
                } else if (response.response.status === 401 || response.response.data === 'Unauthorized') {
                    toast.error('Sorry your session has expired you need to Re-Login to access the Application.');
                    doLogout();
                } else if (response.response.status >= 500) {
                    toast.error('Oops! There was an error trying to process your request. Please try again or contact admin.');
                }
            }

        } catch (error) {
            console.log(error)
        } finally {
            setSpinner(false);
        }
    }

    useEffect(() => {
        getDocumentList()
    }, [])

    const handleDeleteDocument = (id) => {
        Swal({
            title: 'Delete',
            text: 'Are you sure you want to delete document?',
            icon: 'warning',
            dangerMode: true,
            buttons: ['Cancel', 'Delete'],
            modal: false,
        }).then((result) => {
            if (result) {
                deleteDocument(id)
            }
        });
    }

    const deleteDocument = async (id) => {
        try {
            const response = await deleteDocumentById(id);
            if (response) {
                if (response.status === 200) {
                    toast.success("Document deleted successfully")
                    getDocumentList()
                } else if (response.response.status === 401 || response.response.data === 'Unauthorized') {
                    toast.error('Sorry your session has expired you need to Re-Login to access the Application.');
                    doLogout();
                } else if (response.response.status >= 500) {
                    toast.error('Oops! There was an error trying to process your request. Please try again or contact admin.');
                }
            }
        } catch (error) {
            console.warn(error);
        }

    }

    return (
        <>
            <Header title="Documents">
                <Link to='/admin/document/upload' className='btn btn-info'>
                    Upload Document
                </Link>
            </Header>
            <div className='container'>
                <Spinner display={spinner}>
                    {documents?.length > 0 ?
                        <div className='card'>
                            <div className='card-body py-0'>
                                <ul className='list-group list-group-flush'>
                                    {documents?.map((document, index) => {
                                        return (
                                            <li className='list-group-item py-3' key={document?.id}>
                                                <div className='row align-items-center'>
                                                    <div className='col-auto'>
                                                        <img src={`/img/${document?.type?.toLowerCase()}.png`} alt='...' className='avatar-img rounded' style={{ width: '24px', height: '24px' }} />
                                                    </div>
                                                    <div className='col ms-n2'>
                                                        {document?.name}
                                                    </div>
                                                    <div className='col-auto'>
                                                        <button onClick={() => { window.open(document.file_path, '_blank'); toast.success(`${document?.name} downloaded successfully`) }} className='btn btn-sm  btn-light mx-3'>
                                                            <i className='fe fe-download me-2'></i> Download
                                                        </button>
                                                        <button className='btn btn-sm btn-light'>
                                                            <i className='fe fe-trash-2 ' onClick={() => { handleDeleteDocument(document?.id) }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>

                            </div>
                        </div> :
                        (
                            <div className="card">
                                <div className="m-5 text-center">
                                    <div className="row">
                                        <div className="col-lg-4 offset-lg-4 text-center">
                                            <img src="/img/empty.svg" className="img-fluid" alt="no-data-found" />
                                            <p className="mt-3">Looks like you don't have any Documents!</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </Spinner>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps)(AdminDocuments);
